// src/components/BuyCarDropdown.jsx
import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useCity } from '../context/CityContext';
import '../styles/BuyCarDropdown.css';

const BuyCarDropdown = ({ onClose }) => {
  const navigate = useNavigate();
  const { setSelectedCity } = useCity();

  const mpDistrictCities = [
    { label: 'Used cars in Indore', location: 'Indore', path: '/buy-cars?location=Indore' },
    { label: 'Used cars in Mhow', location: 'Mhow', path: '/buy-cars?location=Mhow' },
    { label: 'Used cars in Pithampur', location: 'Pithampur', path: '/buy-cars?location=Pithampur' },
    { label: 'Used cars in Dewas', location: 'Dewas', path: '/buy-cars?location=Dewas' },
    { label: 'Used cars in Ujjain', location: 'Ujjain', path: '/buy-cars?location=Ujjain' },
  ];

  const otherCities = [
    { label: 'Used cars in Bangalore', location: 'Bangalore', path: '/buy-cars?location=Bangalore' },
    { label: 'Used cars in Mumbai', location: 'Mumbai', path: '/buy-cars?location=Mumbai' },
    { label: 'Used cars in Delhi', location: 'Delhi', path: '/buy-cars?location=Delhi' },
    { label: 'Used cars in Noida', location: 'Noida', path: '/buy-cars?location=Noida' },
    { label: 'Used cars in Chennai', location: 'Chennai', path: '/buy-cars?location=Chennai' },
    { label: 'Used cars in Lucknow', location: 'Lucknow', path: '/buy-cars?location=Lucknow' },
    { label: 'Used cars in Delhi NCR', location: 'Delhi NCR', path: '/buy-cars?location=Delhi NCR' },
    { label: 'Used cars in Hyderabad', location: 'Hyderabad', path: '/buy-cars?location=Hyderabad' },
    { label: 'Used cars in Pune', location: 'Pune', path: '/buy-cars?location=Pune' },
    { label: 'Used cars in Gurgaon', location: 'Gurgaon', path: '/buy-cars?location=Gurgaon' },
    { label: 'Used cars in Ahmedabad', location: 'Ahmedabad', path: '/buy-cars?location=Ahmedabad' },
    { label: 'Used cars in Kolkata', location: 'Kolkata', path: '/buy-cars?location=Kolkata' },
    { label: 'Used cars in Jaipur', location: 'Jaipur', path: '/buy-cars?location=Jaipur' },
  ];

  const handleOptionClick = (option) => {
    if (option.location) setSelectedCity(option.location);
    navigate(option.path);
    onClose();
  };

  const handleViewAll = () => {
    navigate('/buy-cars');
    onClose();
  };

  return (
    <div className="buycar-panel">
      {/* Top accent */}
      <div className="buycar-accent-bar" />

      {/* ── View All Cars CTA ── */}
      <button className="buycar-view-all" onClick={handleViewAll}>
        <div className="buycar-view-all-left">
          <div>
            <span className="buycar-view-all-title">View All Cars</span>
            <span className="buycar-view-all-sub">Browse our entire inventory</span>
          </div>
        </div>
        <span className="buycar-view-all-arrow">›</span>
      </button>

      <div className="buycar-body">
        {/* ── LEFT: MP Cities ── */}
        <div className="buycar-left">
          <div className="buycar-section-head">
            <span className="buycar-section-badge"> M.P</span>
            <span className="buycar-section-label">Available Now</span>
          </div>

          <div className="buycar-mp-list">
            {mpDistrictCities.map((city, idx) => (
              <button
                key={idx}
                className="buycar-mp-item"
                onClick={() => handleOptionClick(city)}
                style={{ animationDelay: `${idx * 40}ms` }}
              >
                <div className="buycar-mp-item-left">
                  <span className="buycar-mp-dot" />
                  <span className="buycar-mp-label">{city.label}</span>
                </div>
                {/*<span className="buycar-mp-available">✓ Live</span>*/}
              </button>
            ))}
          </div>
        </div>

        {/* Vertical divider */}
        <div className="buycar-vdivider" />

        {/* ── RIGHT: Other Cities grid ── */}
        <div className="buycar-right">
          <div className="buycar-section-head">
            <span className="buycar-section-badge">All Cities</span>
            <span className="buycar-section-label">More locations</span>
          </div>

          <div className="buycar-cities-grid">
            {otherCities.map((city, idx) => (
              <button
                key={idx}
                className="buycar-city-item"
                onClick={() => handleOptionClick(city)}
                style={{ animationDelay: `${idx * 30}ms` }}
              >
                <span className="buycar-city-label">{city.label}</span>
                <span className="buycar-city-arrow">›</span>
              </button>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default BuyCarDropdown;